import { css } from '@emotion/react';

export const sharedCellContainerStyle = css({ height: '100%' });
